import {
  ChangeDetectionStrategy,
  Component,
  computed,
  viewChild
} from '@angular/core';
import { MatTabNavPanel } from '@angular/material/tabs';
import { BaseComponent } from '~backoffice/app/~shared/abstract-components/base.component';
import { TabLink } from '~backoffice/app/~shared/models/shared.models';
import { SharedModule } from '~backoffice/app/~shared/modules/shared.module';
import { Permission } from '~core/models/roles.models';

@Component({
  selector: 'configuration-layout',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './configuration-layout.component.html',
  styleUrl: './configuration-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfigurationLayoutComponent extends BaseComponent {
  readonly tabPanel = viewChild(MatTabNavPanel);

  readonly links = computed<TabLink[]>(() => {
    const permissions = this.permissions();
    return [
      ...(!!permissions && permissions[Permission.READ_DGI_DASHBOARD_CONFIG]
        ? [
            {
              path: `/dgi-settings/dashboards`,
              icon: 'discover',
              title: 'Statistiques du tableau de bord',
              disabled: false
            }
          ]
        : []),
      ...(!!permissions && permissions[Permission.READ_DGI_SECURITY_CONFIG]
        ? [
            {
              path: `/dgi-settings/security`,
              icon: 'security-lock-stroke-rounded',
              title: 'Paramètres de sécurité des comptes',
              disabled: false
            }
          ]
        : [])
    ];
  });
}
